import { useState } from 'react';

const portfolioItems = [
  {
    id: 1,
    name: 'PRT Propreté',
    type: 'Site Vitrine — Lavage Auto Premium',
    badge: 'Site Vitrine pour Client',
    badgeColor: 'bg-emerald-500',
    link: 'https://prtproprete.fr',
    image: 'https://static.readdy.ai/image/a17d3ae5e640a18a289681692364ae47/a75671a42dd2b3bf0309c1faed68a649.jpeg',
    external: true,
    tags: ['Site Vitrine', 'Réservation en ligne', 'SEO'],
    brandLogo: null as string | null,
    brandText: null as string | null,
  },
  {
    id: 2,
    name: 'MiraFlowers',
    type: 'Site E-commerce — Fleurs & Créations',
    badge: 'Site E-commerce pour Client',
    badgeColor: 'bg-pink-500',
    link: 'https://miraflowers.fr',
    image: 'https://static.readdy.ai/image/a17d3ae5e640a18a289681692364ae47/783a17c9f14067c41497b0c58a29f9f3.jpeg',
    external: true,
    tags: ['E-commerce', 'Paiement en ligne', 'SEO avancé'],
    brandLogo: null as string | null,
    brandText: 'Mira Flowers',
  },
];

export default function PortfolioSection() {
  const [hoveredId, setHoveredId] = useState<number | null>(null);

  return (
    <section className="py-16 sm:py-24 px-4 sm:px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-2xl sm:text-4xl md:text-5xl font-black text-center text-slate-900 mb-4 sm:mb-6">
          Nos <span className="bg-gradient-to-r from-emerald-500 to-teal-500 bg-clip-text text-transparent">Réalisations</span>
        </h2>
        <p className="text-sm sm:text-lg text-slate-500 text-center mb-10 sm:mb-14 max-w-2xl mx-auto">
          Sites livrés en <strong className="text-slate-700">7 jours maximum</strong>, 100&nbsp;% sur mesure et optimisés mobile
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
          {portfolioItems.map((item) => (
            <div key={item.id} className="flex flex-col">
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="group block cursor-pointer"
                onMouseEnter={() => setHoveredId(item.id)}
                onMouseLeave={() => setHoveredId(null)}
              >
                <div className="relative overflow-hidden rounded-2xl border border-slate-100 bg-white transition-all duration-300 hover:-translate-y-1">
                  {/* Image */}
                  <div className="relative w-full h-52 sm:h-60">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                      loading="lazy"
                      decoding="async"
                      width="800"
                      height="600"
                    />

                    {/* Logo de marque — toujours visible sur l'image */}
                    {item.brandText && (
                      <div className="absolute top-3 left-3 z-10">
                        <div className="bg-white/90 backdrop-blur-sm px-3 py-1.5 rounded-xl shadow-md border border-pink-100 flex items-center space-x-1.5">
                          <span className="text-base sm:text-lg font-serif italic text-[#D4949C] leading-none whitespace-nowrap">
                            {item.brandText}
                          </span>
                        </div>
                      </div>
                    )}

                    {/* Overlay hover */}
                    <div className={`absolute inset-0 bg-black/65 flex flex-col items-center justify-center gap-4 transition-opacity duration-300 ${hoveredId === item.id ? 'opacity-100' : 'opacity-0'}`}>
                      <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-white/60 shadow-lg bg-white flex items-center justify-center flex-shrink-0">
                        <img
                          src="https://storage.readdy-site.link/project_files/4b4401ba-15f0-439b-b98a-b01604dbec9f/442a464f-8032-44d1-bac3-ead0a8ffe0a8_1000076481-1.jpg?v=96b293557c056fe8b5a4d02656f71fb5"
                          alt="UzunDigital"
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div className="flex items-center space-x-2 bg-white/20 backdrop-blur-sm border border-white/30 text-white px-5 py-2.5 rounded-full text-sm font-bold">
                        <i className="ri-external-link-line text-base"></i>
                        <span>Voir le site</span>
                      </div>
                    </div>
                  </div>

                  {/* Badge */}
                  <div className="absolute top-3 right-3">
                    <span className={`px-3 py-1 rounded-full text-[10px] sm:text-xs font-bold text-white shadow-md whitespace-nowrap ${item.badgeColor}`}>
                      <i className="ri-verified-badge-fill mr-1"></i>
                      {item.badge}
                    </span>
                  </div>

                  {/* Info bas de l'image */}
                  <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-4 bg-gradient-to-t from-black/85 via-black/40 to-transparent">
                    <h3 className="text-sm sm:text-base font-black text-white">{item.name}</h3>
                    <p className="text-[10px] sm:text-xs text-white/80 mt-0.5">{item.type}</p>
                  </div>
                </div>
              </a>

              {/* Tags */}
              <div className="flex flex-wrap gap-2 mt-3 px-1">
                {item.tags.map((tag, i) => (
                  <span key={i} className="text-[10px] sm:text-xs font-semibold text-slate-500 bg-slate-100 px-2.5 py-1 rounded-full">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Livraison badge */}
        <div className="mt-10 sm:mt-14 flex items-center justify-center gap-2 text-sm sm:text-base text-slate-500">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
            <i className="ri-timer-flash-line text-emerald-500 text-lg"></i>
          </div>
          <span>Chaque site livré en <strong className="text-slate-900">7 jours maximum</strong> · À partir de <strong className="text-slate-900">69€/mois</strong> sans engagement</span>
        </div>
      </div>
    </section>
  );
}
